<div mdbModal #saModal="mdbModal" class="modal fade sa-form" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
  aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content" *ngIf="saForm">
      <!-- <p style="text-align: center; font-weight: bold;">SA FORM</p>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="saModal.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button> -->
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
              <img style="height: 500px;width: 500px;" src="{{saImagePath}}" />

            </div>
          </div>
          <!-- <div class="action-buttons">
            <button mdbBtn class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
              type="submit" (click)="saModal.hide()">close
            </button>
          </div> -->
        </div>

        <!--Grid column-->
      </div>
    </div>
  </div>
</div>